import React from 'react';

export default function LocationSection() {
  const embedUrl = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d351.77696362075056!2d-16.272310695246047!3d28.452582213395525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc41cc942a8fc5f5%3A0x97c1fda406975afc!2sC.%20Anatolio%20de%20Fuentes%20Garc%C3%ADa%2C%202%2C%2038009%20Santa%20Cruz%20de%20Tenerife!5e0!3m2!1ses!2ses!4v1710862270915!5m2!1ses!2ses';

  return (
    <section id="mapa" className="relative py-20 px-4 z-10">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-blue-900 mb-8">Encuéntranos aquí</h2>
        <div className="w-full rounded-lg overflow-hidden shadow-xl">
          <iframe
            src={embedUrl}
            width="100%"
            height="400"
            loading="lazy"
            className="border-0"
            referrerPolicy="no-referrer-when-downgrade"
            title="Mapa de Mundolandia Park"
          />
        </div>
      </div>
    </section>
  );
}
